import { ReactElement } from 'react';
import { getCdnImageUrl } from '@client/routes/utils/url';
import { Props } from './';
import './DangerIcons.scss';

export const DangerIcons = ({ dangerIcons }: Props): ReactElement => (
  <div className='ProductDescription-DangerIconGroup'>
    {dangerIcons.map((icon, key) => (
      <div key={key} className='ProductDescription-DangerIcon'>
        <img src={getCdnImageUrl(icon.link) || ''} alt={icon.name} />
      </div>
    ))}
  </div>
);
